import React from 'react';
import { fleetRoute } from '@/modules/fleet/route';
import { createRoute } from '@tanstack/react-router';

export const fleetSummaryRoute = createRoute({
  getParentRoute: () => fleetRoute,
  path: 'summary',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Fleet/ResumeTab')),
});
